@for (task of visit?.tasks; track task) {
  <sc-padding>
    <sc-flex>
      <div class="icon-space">
        @if (!task.optional) {
          <sc-icon iconClass="fa-circle-exclamation"></sc-icon>
        }
      </div>
      <sc-content-spacer></sc-content-spacer>
      <sc-dictionary-label dictionaryKey="dd.visitor_role_task.{{task.taskId}}.name"></sc-dictionary-label>
      <sc-content-spacer></sc-content-spacer>
      <div></div>
      <sc-content-spacer grow></sc-content-spacer>
      @if (task.done) {
        <sc-icon iconClass="fa-check fa-2x"></sc-icon>
      }
      @if (task.doneBefore) {
        <sc-icon iconClass="fa-circle-check fa-2x"></sc-icon>
      }
      @if (!task.done && !task.doneBefore) {
        <sc-button iconClass="fa-check" dictionaryKey="tmc-visit.ui.visit.confirm-task" (click)="confirmTask(task)"></sc-button>
      }
    </sc-flex>
  </sc-padding>
  <div class="divider"></div>
}
